module.exports = __webpack_public_path__ + "static/img/sub01.fd757ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/sub01.png
// module id = nR1H
// module chunks = 1